export default "__VITE_ASSET__C6Jpju2K__"